import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Spinner, Text } from "@chakra-ui/react";
import { useData } from "../../data";

const Trends = () => {
    const {
        data,
        isLoading,
        refetch
    } = useData(
        `feed/trends`, 10000
    );
    const [trends, setTrends] = useState([])

    useEffect(() => {
        if(data?.data?.trends?.length > 0){
            setTrends(data?.data?.trends)
        }
    }, [data]);

    return (
        <div className="bg-white shadow-md rounded-lg p-4 w-full max-w-sm border border-gray-200">
            <Text className="text-lg font-bold">
                What's Happening
            </Text>    

            {isLoading ? (
                <Spinner size={"sm"} />
            ) : trends.length === 0 ? (
                <Box className="py-14">
                    <Text className="text-sm text-gray-700 text-center">
                        No trends to show
                    </Text>
                </Box>
            ) : (
                <Box className="py-5">

                    <ul className="space-y-2">
                        {trends.map((trend, index) => (
                            <li
                                key={index}
                                className="flex justify-between items-center px-3 py-2 bg-gray-50 rounded hover:bg-gray-100 transition"
                            >
                            <span className="text-sm text-gray-700">{trend.category}</span>
                            <span className="text-xs bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full">
                                {trend.post_count} posts
                            </span>
                            </li>
                        ))}
                    </ul>
                </Box>
            )}
        </div>
    );
};

export default Trends;
